<template>
  <div class="container">
    <div class="row mt-2">
      <!-- Liberar Usuáio -->
      <div>
        <div class="d-flex justify-content-center">
          <div class="card w-50 col-12">
            <div>
              <h4
                class="text-gray font-weight-light text-center"
                for="input-reason"
              >
                Liberar usuário
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api";
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
  name: "unlock-user",
  data() {
    return {};
  },
  async mounted() {
    await this.unlockUser();
  },
  methods: {
    async unlockUser() {
      try {
        const token = this.$route.params.token;
        await api.post(`unlock-user/${token}`);
        toast.success(
          "Usuário desbloqueado com sucesso! Faça o login novamente."
        );
        this.$router.push(`/entrar`);
      } catch (e) {
        let message = "Ocorreu um erro ao salvar a nova senha";
        if (e.response.data.message) message = e.response.data.message;
        toast.error(message);
      }
    },
  },
};
</script>
<style scoped>
a {
  text-decoration: none;
}
.card {
  border-radius: 20px;
  padding: 40px;
}
.btn {
  border-radius: 40px;
}
.text-gray {
  color: #545454;
}
.sign-button {
  width: 35%;
}
.bold {
  font-weight: bold;
}
.rounded {
  border-radius: 20px;
}
.desc {
  font-size: 22px;
}
.link-button {
  cursor: pointer;
}
</style>
